"use client";
import ComponentTraverser from "components/ComponentTraverser/ComponentTraverser";
import PageLayout from "components/PageLayout/PageLayout";
import { filter_gutenberg_blocks } from "hooks/utils/gutenberg";

const FrontPage = ({page}) => {
  const gutenberg = page?.gutenberg || [];
  const filter_gutenberg = filter_gutenberg_blocks(gutenberg);
  return (
    <>
      <PageLayout front>
        {filter_gutenberg?.map((item, idx) => (
          <ComponentTraverser
            data={item}
            key={idx}
          />
        ))}
      </PageLayout>
    </>
  );
}
 
export default FrontPage;